import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    Sidebar,
    WarningModal,
    NotificationSystem,
    updateTabEvents,
    SidebarMenuMapType,
    EmailConfirmationNotification,
} from 'components';
import { cloneDeep } from 'lodash';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useShowGlobalErrorModal } from 'hooks';
import sidebarTabs from '../../routes/SidebarTabs';
import { RouteComponentProps, useHistory, withRouter } from 'react-router';

const PROFILE_TABS = [
    {
        path: '/my-profile',
        name: 'Настройки профиля',
        mini: 'НП',
    },
];

const SidebarContainer: React.FC<Props> = (
  {
      onFetchProfile,
      startEventStatePoll,
      stopEventStatePoll,
      events,
      errors,
      auth,
      location,
      notifications,
      cleanNotifications,
      sendConfirmationEmail,
      onLogout,
  },
) => {
    const { push: onPush } = useHistory();
    const [tabs, setTabs] = useState(sidebarTabs);
    const { showModal, toggleModal } = useShowGlobalErrorModal(errors);

    React.useEffect(() => {
        onFetchProfile();
        if (process.env.REACT_APP_LOCAL_RUN_TESTS !== 'true') {
            startEventStatePoll();
        }
        return () => {
            stopEventStatePoll();
        };
    }, []);

    React.useEffect(() => {
        setTabs(sidebarTabs.map(t => updateTabEvents(t, events, menuEventsMap)));
    }, [events]);

    const newTabs = React.useMemo(() => {
        if (!auth || !auth.profile) {
            return tabs;
        }
        const tabsForRender = cloneDeep(sidebarTabs)
        .filter(el => !el.role || el.role.includes(auth.profile.status))
        .map((tab) => {
            if (!tab.list) return tab;
            return {
                ...tab,
                list: tab.list
                .filter(el => !el.role || el.role.includes(auth.profile.status)),
            };
        });

        // if (!auth.profile.registrationCompleted && !auth.profile.chairman) {
        //     tabsForRender = [];
        //     tabsForRender.push(registrationCompletionTab);
        // }

        return tabsForRender;
    }, [auth]);

    if (!auth) return null;

    return (
      <>
          <Sidebar
            profile={auth.profile}
            location={location}
            profileTabs={PROFILE_TABS}
            onLogout={onLogout}
            tabs={newTabs}
          />
          {errors.error && errors.handler === 'global' && !errors.error.failures && (
              <WarningModal
                title={errors.error.message}
                show={showModal}
                onHide={() => toggleModal(false)}
                onAccess={() => toggleModal(false)}
                accessBtnTittle="Вернуться"
                titleClassNames="text-danger"
              >
                  <p>Код ошибки:{errors.error.code}</p>
                  <p>Тип ошибки:{errors.error.type}</p>
              </WarningModal>
            )}
          <NotificationSystem
            notifications={notifications}
            cleanNotifications={cleanNotifications}
          />
          <EmailConfirmationNotification
            profile={auth && auth.profile}
            onPush={onPush}
            sendConfirmationEmail={captcha => sendConfirmationEmail({ captcha })}
            cleanNotifications={cleanNotifications}
            apiError={errors.error}
          />
      </>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
    errors: state.errors,
    notifications: state.notifications,
    events: state.eventsState,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onFetchProfile: dispatch.auth.fetchProfile,
    cleanNotifications: dispatch.notifications.clean,
    startEventStatePoll: dispatch.eventsState.startEventStatePoll,
    stopEventStatePoll: dispatch.eventsState.stopEventStatePoll,
    sendConfirmationEmail: dispatch.auth.sendConfirmationEmailAsync,
    onLogout: dispatch.auth.logout,
});

export default withRouter(connect(mapState, mapDispatch)(SidebarContainer));

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & RouteComponentProps;

const menuEventsMap: SidebarMenuMapType = {
    'Запросы на участие': 'ExpertInvitation',
    'Проводимые аккредитации': 'ExamTimetable',
    'Обработка аккредитаций': 'ExamInProcessing',
};
